import { Component, Shark, Utils } from "shark-mvc";
import { Modal } from "bootstrap";

import templateContent from "./attachments-viewer-modal.html";

import attachmentManager from "../../controllers/attachmentManager";

class AttachmentsViewerComponent extends Component {
	constructor () {
		super("attachmentsViewerComponent");
		this.addTemplate("", templateContent);
	}

	afterLoad () {
		const modalNode = document.querySelector("#attachmentsViewerModal");

		if (modalNode) {
			this.modal = new Modal(modalNode, {
				keyboard: false
			});
		}
	}

	async showAttachmentBtn_clickHandler (event, data) {
		const attachViewingTask = Utils.safp(Shark.$store.taskList, "guid", data.guid);

		if (attachViewingTask) {
			Shark.set({
				attachViewingTask,
			});

			await attachmentManager.getTaskAttachmentsForTask(attachViewingTask);

			Shark.render();// dovrà sparire con aggiornamento di Shark
			this.open();
		}
	}

	close () {
		if (this.modal) {
			this.modal.hide();
			this.set("open", false);
		}

		Shark.set({
			attachViewingTask: null,
		});
	}
	
	closeActivitySettingsModalBtn_clickHandler () {
		this.close();
	}
	
	async init () {
		this.set("open", false);
	}
	
	open () {
		if (this.modal) {
			this.modal.show();
			this.set("open", true);
		}
	}
}

const attachmentsViewerComponent = new AttachmentsViewerComponent();

Shark.registerComponent(attachmentsViewerComponent);

export default attachmentsViewerComponent;
